export { default } from './BlockMoral'